import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Model from './ModelBdrule.mjs'
import RuleType from './RuleType.jsx'

const PropertiesPaneBatchBdrule = (props) => (
    <PropertiesPane
        controllers={
            <>
                <Select
                    options={RuleType}
                    prop="ruleType"
                />

                <TagSelect prop="ruleKey" />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneBatchBdrule
